module.exports = __webpack_public_path__ + "static/media/6.f6227b52.jpg";